import styled from 'styled-components';

// Components
import ModalContainer from '../../containers/ModalContainer';

export const ModalContainerStyled = styled(ModalContainer)``;

/**
 * Cuerpo del modal. El título y la ✕ los pinta la cabecera del
 * `ModalContainer` (prop `title`), así que aquí solo van los campos y los
 * botones.
 */
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: flex-end;

  > button {
    min-width: 12rem;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet *
    theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    > button {
      width: 100%;
    }
  }
`;
